import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useStore, useToast, useAuth, usePage, useModal } from "@/comn/hooks"; // hook
import {
    URLS,
    APIS,
    SF_LPCO_FEE_MDFY_SRCH,
    SG_LPCO_FEE_MDFY_LIST,
} from "@/tz/go/egaz/osci/lpco/fee/services/OsciLpcoFeeService";
import dayjs from "dayjs";
import { OSCI0205012Q } from "./OSCI0205012Q";

/*
 * Fee Modification Request List
 * !== 수수료 변경 신청 목록 (OSCI_LPCO_FEE_MDFY_R 기준) ==!
 */
export const OSCI0205009Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "cstmCd" },
            { area: "coCd" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0096" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0009", "auth_osci0021", "auth_osci0003"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [isVisibleNewBtn, setIsVisibleNewBtn] = useState(false); // User define State !== 사용자 정의 스테이트 ==!

    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Fee Modification Request List Search !== 수수료 변경 신청 목록 검색 ==!
        bllReusSrch: useForm({
            defaultSchema: SF_LPCO_FEE_MDFY_SRCH,
            defaultValues: {
                ...(pgeStore?.form || { reusCd: ["A"] }),
                mdfyStrtDt: comnUtils.getDate({ m: -1 }),
                mdfyEndDt: comnUtils.getDate(),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Fee Modification Request List !== 수수료 변경 신청 목록 ==!
        updtList: useGrid({
            defaultSchema: SG_LPCO_FEE_MDFY_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Fee Modification Request List !== 수수료 변경 신청 목록 조회 ==!
        getFeeUpdateList: useFetch({
            api: (page = grid.updtList.page) => {
                let data = {
                    ...form.bllReusSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };
                return APIS.getFeeUpdateList(data, page, grid.updtList.size);
            },
            enabled: comnUtils.isEmpty(form.bllReusSrch.errors),
            key: [grid.updtList.page, grid.updtList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.bllReusSrch.getValues(),
                    page: grid.updtList.page,
                    size: grid.updtList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Fee Modification Request List !== 수수료 변경 신청 목록 조회 ==!
        getFeeUpdateList: () => {
            form.bllReusSrch.handleSubmit(
                (data) => {
                    grid.updtList.setPage(0);
                    fetch.getFeeUpdateList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_updtList: {
            cell: {
                appNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }} title={`${rowValues.appNm}`}>
                            <Link to={`${URLS.osci0205010q}/${rowValues.bllMgmtId}`}>{`${rowValues.appNo}`}</Link>
                        </span>
                    );
                },
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }} title={`${rowValues.bllNo}:${rowValues.mdfyRqstSn}`}>
                            <Link to={`${URLS.osci0205010q}/${rowValues.bllMgmtId}`}>{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
                // mdfyStatCd: (props: any) => {
                //     const { rowValues } = props;
                //     return (
                //         <Link
                //             to=""
                //             onClick={() => {
                //                 popupFunc.openFeeHistPopup(rowValues.feeId); // 수수료 변경 이력 목록 팝업
                //             }}
                //         >
                //             <Layout direction="col" gap={0} valign="center" align="center">
                //                 <FormControl
                //                     type="select"
                //                     area="comnCd"
                //                     comnCd="OSC0254"
                //                     value={rowValues.mdfyStatCd}
                //                     viewType="both"
                //                     edit={false}
                //                 />
                //             </Layout>
                //         </Link>
                //     );
                // },
            },
        },
    };

    // 팝업 호출
    const popupFunc = {
        openFeeHistPopup: (feeId: any) => {
            modal.openModal({
                content: <OSCI0205012Q state={{ feeId }} />,
                size: "lg",
                draggable: true,
            });
        },
    };
    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // 버튼 컨트롤
        if (auth.get("authList").includes("auth_osci0021") || auth.get("authList").includes("auth_osci0003")) {
            setIsVisibleNewBtn(true);
        }
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.appNo}></Group.Control>
                                <Group.Control {...form.bllReusSrch.schema.ucrNo}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.mdfyDt}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllReusSrch.schema.bllNo}></Group.Control>
                                <Group.Control {...form.bllReusSrch.schema.mdfyStatCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllReusSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getFeeUpdateList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.updtList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,
                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.updtList.grid}
                            data={fetch.getFeeUpdateList.data?.updtList}
                            render={render.grid_updtList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            {isVisibleNewBtn && (
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.osci0205011s + "/INSERT");
                        }}
                    ></Button>
                </Layout.Left>
            )}
        </Page>
    );
};
